import Component from '@glimmer/component';
import GoogleMaps from 'garaje/components/google-maps';

interface LocationMapSignature {
  Args: {
    isLoading?: boolean;
    latitude?: number | null;
    longitude?: number | null;
  };
  Element: HTMLDivElement;
}

export default class LocationMapComponent extends Component<LocationMapSignature> {
  get hasCoordinates(): boolean {
    return this.args.latitude != null && this.args.longitude != null;
  }

  <template>
    {{#if this.hasCoordinates}}
      <div data-test-map class="googleMap {{if @isLoading 'isEditing'}}" ...attributes>
        <GoogleMaps @latitude={{@latitude}} @longitude={{@longitude}} />
      </div>
    {{else}}
      <div data-test-map-placeholder class="googleMapPlaceholder icon-mapPin flex items-center" ...attributes>
        <p class="flex-auto mb-0 text-carbon-50 text-sm text-center mt-10">Enter your address<br />to see it on the map</p>
      </div>
    {{/if}}
  </template>
}
